(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('ApplicationParameter', ApplicationParameter);

    ApplicationParameter.$inject = ['$resource'];

    function ApplicationParameter ($resource) {
        var resourceUrl =  'api/application-parameters/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
